<template lang="pug">
v-container.mb-6
  v-card.rounded-lg.elevation-25.pa-4
    div(v-if="selectedTheme")
  
      
        .d-md-flex.justify-space-between
          div(style="width: 100%")
              v-card-title {{$t('create.addInformation.title')}}
              v-card-subtitle 
                | {{$t('create.addInformation.subtitle')}} 
              v-card-text(style="width: 100%")
                MotionForm
          .px-4.mb-8.d-none.d-md-flex
            v-card.ma-md-4.rounded-lg.elevation-dense( min-width="330")
              v-card-text.text-center
                  v-avatar.elevation-dense(size="90" color="primary")
              
                      v-img(:src="selectedTheme.imageUrl" v-if="selectedTheme.imageUrl")
              v-card-title.justify-center.text-center {{selectedTheme.title}}
    div(v-else style="height: 100%; width: 100%; min-width: 100px; min-height: 300px" )
      v-skeleton-loader( style="opacity: 1; height: 100%; width: 100%; min-width: 100px; min-height: 300px" type="image"  min-height="300")
      
</template>
<script>
import { mapFields } from "vuex-map-fields";
import MotionForm from "@/components/create/MotionForm";
export default {
  components: {
    MotionForm,
  },
  computed: {
    ...mapFields("create", {
      selectedTheme: "selectedTheme",
      motionDraft: "motionDraft",
    }),
  },
};
</script>
